import "./App.css";

// Boostrap Imports
import "bootstrap/dist/css/bootstrap.min.css";

// Pages
import HomeWithModal from "./Pages/HomeWithModal";
// import Home from "./Pages/Home";
import Program from "./Pages/Program";

// Routing
import { Routes, Route, HashRouter } from "react-router";

function App() {
  return (
    <div className="App">
      <HashRouter>
        <Routes>
          <Route index element={<HomeWithModal />} />
          <Route path="/program" element={<Program />} />
        </Routes>
      </HashRouter>
    </div>
  );
}

export default App;
